import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
import "@fontsource/nunito/800.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource-variable/dm-sans";
import "./styles/index.css";
import { App } from "@/App";
import "./feedbackWidget";

const rootEl = document.querySelector("#root");
if (!rootEl) {
  throw new Error("Root element #root not found in document.");
}
createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
